import { getErrorFromObject } from '../../logging/genericInformationLogging';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import { getSxSViewStore } from 'owa-group-files-hub-store';
import { lazySetPreviewError } from 'owa-sxsdata';

export default async function handleSetViewStateFailure(
    error: Error,
    errorMessage: string,
    datapoint: PerformanceDatapoint
) {
    const setPreviewError = await lazySetPreviewError.import();
    await setPreviewError(getSxSViewStore().viewState, errorMessage);
    datapoint.endWithError(DatapointStatus.ServerError, getErrorFromObject(error));
}
